<template>
  <input v-model="date" class="w-full p-4 bg-gray-200" type="date" :min="minDate | dateFormatHyphen" :max="maxDate | dateFormatHyphen" disabled="isDisabled" />
</template>

<script>
import moment from 'moment'

export default {
  props: {
    serviceArea: {
      type: Object,
      required: true
    }
  },
  computed: {
    date: {
      get () {
        return this.$store.getters['reservation/getDate']
      },
      set (value) {
        const time = this.$store.getters['reservation/getTime']
        this.$store.dispatch('reservation/updateDateTime', moment(value + ' ' + time))
      }
    },
    minDate: function () {
      return moment()
    },
    maxDate: function () {
      return this.serviceArea.nextDayReservation ? moment().add(1, 'day') : moment()
    },
    isDisabled: function () {
      return !this.serviceArea.nextDayReservation
    }
  }
}
</script>
